<script setup lang="ts"></script>
<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.850098"
      y="1.25"
      width="7.5"
      height="7.5"
      rx="1.25"
      stroke="#98A2B3"
      stroke-width="1.5"
    />
    <rect
      x="0.850098"
      y="12.25"
      width="7.5"
      height="7.5"
      rx="1.25"
      stroke="#98A2B3"
      stroke-width="1.5"
    />
    <rect
      x="0.850098"
      y="23.25"
      width="7.5"
      height="7.5"
      rx="1.25"
      stroke="#98A2B3"
      stroke-width="1.5"
    />
    <rect
      x="11.8501"
      y="1.25"
      width="7.5"
      height="7.5"
      rx="1.25"
      stroke="#98A2B3"
      stroke-width="1.5"
    />
    <rect
      x="11.8501"
      y="12.25"
      width="7.5"
      height="7.5"
      rx="1.25"
      stroke="#98A2B3"
      stroke-width="1.5"
    />
    <rect
      x="11.8501"
      y="23.25"
      width="7.5"
      height="7.5"
      rx="1.25"
      stroke="#98A2B3"
      stroke-width="1.5"
    />
    <rect
      x="22.8501"
      y="23.25"
      width="7.5"
      height="7.5"
      rx="1.25"
      stroke="#98A2B3"
      stroke-width="1.5"
    />
    <rect
      x="22.8501"
      y="1.25"
      width="7.5"
      height="7.5"
      rx="1.25"
      fill="#84ADFF"
      stroke="#004EEB"
      stroke-width="1.5"
    />
    <rect
      x="22.8501"
      y="12.25"
      width="7.5"
      height="7.5"
      rx="1.25"
      stroke="#98A2B3"
      stroke-width="1.5"
    />
  </svg>
</template>
